export const METRIC_REGEX = /\^\*([^*]+?)\*\^/g;

export const NUMBER_KEYS = /[0-9.]/;
export const STRING_KEYS = /[가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z]/;
export const OPERATOR_KEYS = /[+\-*/()]/; // FORMULA_OPERATOR_KEYS + CONDITION_OPERATOR_KEYS
export const FORMULA_OPERATOR_KEYS = /[+\-*/()]/;
export const CONDITION_OPERATOR_KEYS = /[()*/()]/;
export const METRIC_DELIMITER_KEYS = /[\^*]/;

export const INVALID_COMMANDS = [
  // move line
  'Alt-ArrowUp',
  'Alt-ArrowDown',
  'Shift-Alt-ArrowUp',
  'Shift-Alt-ArrowDown',
  // delete
  'Ctrl-Backspace',
  'Delete',
  'Alt-Delete',
  'Ctrl-Delete',
  'Cmd-Delete',
  // comment
  'Cmd-/',
  // etc
  'Ctrl-i',
  'Ctrl-[',
  'Ctrl-]',
];

export const TOKEN_TYPES = {
  METRIC: 'metric',
  OPERATOR: 'operator',
  STRING: 'string',
  NUMBER: 'number',
};
